<template>
      <div class="ixat-container">
          <div class="ixat-header-wrapper">
              <h1 class="ixat-header">{{name}}</h1>
          </div>
          <img v-on:click="open()" class="ixat-img" v-bind:src="iconPath"/>
          <div v-if="this.pressed" v-on:click="close()" class="modal">
              <div class="modal-content">
                  <div class="modal-wrapper">
                    <img class="ixat-img" v-bind:src="path"/>
                  </div>
              </div>
          </div>
      </div>
</template>

<style>
.ixat-container{
    margin-top: 30px;
}
.ixat-img{
    width: 100%;
    height: auto;
    margin: 0 !important;
    display: block;

}
.ixat-header-wrapper{
    width: 100%;
    padding: 5px;
    padding-left: 12px;
    padding-bottom: 12px;
    box-sizing: border-box;
    border-radius: 12px 12px 0px 0px;
    background: rgb(20,20,20);
}
.ixat-header{
    margin: 10px;
}
.modal{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999999;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.8);
    display: table;
}
.modal-content{
    display: table-cell;
    vertical-align: middle;
}
.modal-wrapper{
    max-width: 1200px;
    margin: 0 auto;
}
</style>


<script>
export default{
    data() {
        return {
            publicPath: process.env.BASE_URL,
            pressed: false,
        }
    },
    name: 'IxatImage',
    props: ['name', 'src'],
    methods:{
        open(){
            this.pressed = true;
        },
        close(){
            this.pressed = false;
        },
    },
    computed: {
        path(){
            return this.publicPath + "ixat/"+ this.src +".jpg";
        },
        iconPath(){
            return this.publicPath + "ixat/icon-"+ this.src +".jpg";
        }
    }
}
</script>
